module.exports = __webpack_public_path__ + "fonts/iconfont.44b1d71.eot";